export default {
    loginTeacher:       { method: 'post',   url: 'login/teacher'},
    loginTeacherReload: { method: 'post',   url: 'login/teacher/reload'},
    logoutTeacher:      { method: 'post',   url: 'logout/teacher' },
    accessTeacher:      { method: 'post',   url: 'login/teacher/access'},
    authTeacher:        { method: 'post',   url: 'login/teacher/auth'},
    tokenTeacher:       { method: 'post',   url: 'login/teacher/access/token/generate'},
    checkEmailTeacher:  { method: 'post',   url: 'auth/teacher/check-email'},
    callbackTeacher:    { method: 'post',   url: 'auth/teacher/callback'},
}